import { DataBean } from "../DataBean";

export class BudgetAccountantOperation extends DataBean {

    public async getBudgetAccountantOperationCatalog(arg: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getBudgetAccountantOperationCatalog_Number", [arg]);
    }

    public async getValidBudgetAccountantMovementTypeConstants(arg: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getValidBudgetAccountantMovementTypeConstants_Number", [arg]);
    }

    public async getBudgetAccountantMovementJsonService(idBudgetAccountantOperation: number, idAccount: number, movementList: number, idEmployee: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "String_getBudgetAccountantMovementJsonService_Number_Number_java.util.List_Number", [idBudgetAccountantOperation, idAccount, movementList, idEmployee]);
    }

    public async getPaymentHeaderJson(idPaymentHeader: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "String_getPaymentHeaderJson_Number", [idPaymentHeader]);
    }

    public async getBudgetAccountantOperationJsonRequest(idProcess: number, processDate: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "String_getBudgetAccountantOperationJsonRequest_Number_java.util.Date", [idProcess, processDate]);
    }

    public async getBudgetAccountantOperationJsonResponse(idProcess: number, processDate: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "String_getBudgetAccountantOperationJsonResponse_Number_java.util.Date", [idProcess, processDate]);
    }

    public async invokeBudgetAccountantOperation(properties: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.Map_invokeBudgetAccountantOperation_java.util.Map", [properties]);
    }

    public async executeBudgetAccountantOperation(idProcess: any, processDate: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "String_executeBudgetAccountantOperation_Number_java.util.Date", [idProcess, processDate]);
    }

    public async updateBudgetAccountantOperation(bean: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.admin.BudgetAccountantOperation_updateBudgetAccountantOperation_com.quickdataerp.bean.admin.BudgetAccountantOperation", [
            {
                "DataBeanProperties": bean,
                "DataBeanName": "com.quickdataerp.bean.admin.BudgetAccountantOperation"
            }
        ]);
    }
    public async getBudgetAccountantOperationJsonTopology(idBudgetAccountantOperation: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.Map_getBudgetAccountantOperationJsonTopology_Number", [
            idBudgetAccountantOperation
        ]);
    }
    public async getCDPBudgetInfoRender(page: number, rows: number, props: Record<string, any>): Promise<any> {
        return this.getCustomService("FinanceCore",
            "com.advantage.shared.Report_getCDPBudgetInfoRender_Number_Number_java.util.Map", [
            page, rows, props
        ]);
    }
    public async setBudgetInfoToCDP(idBudgetProduct: number, idBudgetActivity: number, goalScore: number, idProject: number, bpinCode: number, idDocument: number, documentDate: any, idEmployee: number, createPdf: boolean): Promise<any> {
        return this.getCustomService(
            "QuickDataERPCore",
            "com.quickdataerp.bean.accountant.AccountantDocument_setBudgetInfoToCDP_Number_Number_Number_Number_Number_Number_java.util.Date_Number_Boolean",
            [idBudgetProduct, idBudgetActivity, goalScore, idProject, bpinCode, idDocument, documentDate, idEmployee, createPdf]
        );
    }

}
